import { NgModule } from '@angular/core';

import { SharedModule } from '@shared';

import { CompaniesSortSelectorComponent } from './components/sort-selector/companies-sort-selector.component';
import { CompaniesFilterRoutingModule } from './filter-routing.module';
import { CompaniesFilterComponent } from './filter.component';
import { CompaniesFilterModalComponent } from './filter.modal.container';
import { ReactiveFormsModule } from '@angular/forms';

const containers = [
  CompaniesFilterComponent,
  CompaniesFilterModalComponent,
  CompaniesSortSelectorComponent,
];

@NgModule({
  imports: [SharedModule, CompaniesFilterRoutingModule, ReactiveFormsModule],
  declarations: [...containers],
  exports: [...containers],
})
export class CompaniesFilterModule {}
